import { GraduationCap } from '@lucide/vue'
import type { PortalModule } from '@/shell/module-registry'

export const coursesModule: PortalModule = {
  key: 'courses',
  title: '课程中心',
  icon: GraduationCap,
  basePath: '/courses',
  order: 20,
  defaultPath: '/courses',
  nav: [{ label: '课程中心', to: '/courses' }],
  routes: [
    { path: '', name: 'courses-list', component: () => import('./pages/CourseList.vue') },
    {
      path: ':centerId',
      name: 'courses-detail',
      component: () => import('./pages/CourseDetail.vue'),
    },
    {
      path: ':centerId/learn',
      name: 'courses-learn',
      component: () => import('./pages/CourseLearn.vue'),
    },
  ],
}
